import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb28h1l6umahrlb as Char__compareTo_impl_ypi4mb,
  toString22rbkbhdb5cl2 as toString,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contains2el4s70rdq4ld as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpHeadersClass;
function HttpHeaders() {
  if (HttpHeadersClass === VOID) {
    class $ {
      constructor() {
        HttpHeaders_instance = this;
        this.a51_1 = 'Accept';
        this.b51_1 = 'Accept-Charset';
        this.c51_1 = 'Accept-Encoding';
        this.d51_1 = 'Accept-Language';
        this.e51_1 = 'Accept-Ranges';
        this.f51_1 = 'Age';
        this.g51_1 = 'Allow';
        this.h51_1 = 'ALPN';
        this.i51_1 = 'Authentication-Info';
        this.j51_1 = 'Authorization';
        this.k51_1 = 'Cache-Control';
        this.l51_1 = 'Connection';
        this.m51_1 = 'Content-Disposition';
        this.n51_1 = 'Content-Encoding';
        this.o51_1 = 'Content-Language';
        this.p51_1 = 'Content-Length';
        this.q51_1 = 'Content-Location';
        this.r51_1 = 'Content-Range';
        this.s51_1 = 'Content-Type';
        this.t51_1 = 'Cookie';
        this.u51_1 = 'DASL';
        this.v51_1 = 'Date';
        this.w51_1 = 'DAV';
        this.x51_1 = 'Depth';
        this.y51_1 = 'Destination';
        this.z51_1 = 'ETag';
        this.a52_1 = 'Expect';
        this.b52_1 = 'Expires';
        this.c52_1 = 'From';
        this.d52_1 = 'Forwarded';
        this.e52_1 = 'Host';
        this.f52_1 = 'HTTP2-Settings';
        this.g52_1 = 'If';
        this.h52_1 = 'If-Match';
        this.i52_1 = 'If-Modified-Since';
        this.j52_1 = 'If-None-Match';
        this.k52_1 = 'If-Range';
        this.l52_1 = 'If-Schedule-Tag-Match';
        this.m52_1 = 'If-Unmodified-Since';
        this.n52_1 = 'Last-Modified';
        this.o52_1 = 'Location';
        this.p52_1 = 'Lock-Token';
        this.q52_1 = 'Link';
        this.r52_1 = 'Max-Forwards';
        this.s52_1 = 'MIME-Version';
        this.t52_1 = 'Ordering-Type';
        this.u52_1 = 'Origin';
        this.v52_1 = 'Overwrite';
        this.w52_1 = 'Position';
        this.x52_1 = 'Pragma';
        this.y52_1 = 'Prefer';
        this.z52_1 = 'Preference-Applied';
        this.a53_1 = 'Proxy-Authenticate';
        this.b53_1 = 'Proxy-Authentication-Info';
        this.c53_1 = 'Proxy-Authorization';
        this.d53_1 = 'Public-Key-Pins';
        this.e53_1 = 'Public-Key-Pins-Report-Only';
        this.f53_1 = 'Range';
        this.g53_1 = 'Referer';
        this.h53_1 = 'Retry-After';
        this.i53_1 = 'Schedule-Reply';
        this.j53_1 = 'Schedule-Tag';
        this.k53_1 = 'Sec-WebSocket-Accept';
        this.l53_1 = 'Sec-WebSocket-Extensions';
        this.m53_1 = 'Sec-WebSocket-Key';
        this.n53_1 = 'Sec-WebSocket-Protocol';
        this.o53_1 = 'Sec-WebSocket-Version';
        this.p53_1 = 'Server';
        this.q53_1 = 'Set-Cookie';
        this.r53_1 = 'SLUG';
        this.s53_1 = 'Strict-Transport-Security';
        this.t53_1 = 'TE';
        this.u53_1 = 'Timeout';
        this.v53_1 = 'Trailer';
        this.w53_1 = 'Transfer-Encoding';
        this.x53_1 = 'Upgrade';
        this.y53_1 = 'User-Agent';
        this.z53_1 = 'Vary';
        this.a54_1 = 'Via';
        this.b54_1 = 'Warning';
        this.c54_1 = 'WWW-Authenticate';
        this.d54_1 = 'Access-Control-Allow-Origin';
        this.e54_1 = 'Access-Control-Allow-Methods';
        this.f54_1 = 'Access-Control-Allow-Credentials';
        this.g54_1 = 'Access-Control-Allow-Headers';
        this.h54_1 = 'Access-Control-Request-Method';
        this.i54_1 = 'Access-Control-Request-Headers';
        this.j54_1 = 'Access-Control-Expose-Headers';
        this.k54_1 = 'Access-Control-Max-Age';
        this.l54_1 = 'X-Http-Method-Override';
        this.m54_1 = 'X-Forwarded-Host';
        this.n54_1 = 'X-Forwarded-Server';
        this.o54_1 = 'X-Forwarded-Proto';
        this.p54_1 = 'X-Forwarded-For';
        this.q54_1 = 'X-Forwarded-Port';
        this.r54_1 = 'X-Request-ID';
        this.s54_1 = 'X-Correlation-ID';
        this.t54_1 = 'X-Total-Count';
        this.u54_1 = 'Last-Event-ID';
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.v54_1 = ['Transfer-Encoding', 'Upgrade'];
        this.w54_1 = asList(this.v54_1);
      }
      x54(name) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(name)) {
          var item = charSequenceGet(name, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) <= 0 || isDelimiter(item)) {
            throw IllegalHeaderNameException().i55(name, _unary__edvuaz);
          }
        }
      }
      y54(value) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(value)) {
          var item = charSequenceGet(value, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
            throw IllegalHeaderValueException().p55(value, _unary__edvuaz);
          }
        }
      }
    }
    initMetadataForObject($, 'HttpHeaders');
    HttpHeadersClass = $;
  }
  return HttpHeadersClass;
}
var HttpHeaders_instance;
function HttpHeaders_getInstance() {
  if (HttpHeaders_instance === VOID)
    new (HttpHeaders())();
  return HttpHeaders_instance;
}
var UnsafeHeaderExceptionClass;
function UnsafeHeaderException() {
  if (UnsafeHeaderExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static u55(header) {
        var $this = this.n2('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly');
        captureStack($this, $this.t55_1);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsafeHeaderException');
    UnsafeHeaderExceptionClass = $;
  }
  return UnsafeHeaderExceptionClass;
}
function isDelimiter(ch) {
  return contains('"(),/:;<=>?@[\\]{}', ch);
}
var IllegalHeaderNameExceptionClass;
function IllegalHeaderNameException() {
  if (IllegalHeaderNameExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static i55(headerName, position) {
        var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charCodeAt(headerName, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerName, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.n2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.h55_1);
        $this.f55_1 = headerName;
        $this.g55_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderNameException');
    IllegalHeaderNameExceptionClass = $;
  }
  return IllegalHeaderNameExceptionClass;
}
var IllegalHeaderValueExceptionClass;
function IllegalHeaderValueException() {
  if (IllegalHeaderValueExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static p55(headerValue, position) {
        var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charCodeAt(headerValue, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerValue, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.n2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.o55_1);
        $this.m55_1 = headerValue;
        $this.n55_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderValueException');
    IllegalHeaderValueExceptionClass = $;
  }
  return IllegalHeaderValueExceptionClass;
}
//region block: exports
export {
  HttpHeaders_getInstance as HttpHeaders_getInstance2ik2fiom4sc0n,
  UnsafeHeaderException as UnsafeHeaderException3ncvrrp48xjzq,
};
//endregion

//# sourceMappingURL=HttpHeaders.mjs.map
